import { useLocation, useParams } from 'react-router-dom';
import './CmrGrievanceRegister.css';
import React, { useState, useEffect, useCallback } from 'react';
import { jsPDF } from 'jspdf';
import pds from './pds.PNG';
import ExcelJS from 'exceljs';
import { format } from 'date-fns';
import axios from 'axios';
const CmrGrievanceRegister = () => {
    const [panchayatDetails, setPanchayatDetails] = useState([]);
    const { district, subDivision, block, panchayat, inspection } = useParams();
    const location = useLocation();
    const [currentLevel, setCurrentLevel] = useState("district");
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedDistrictName, setSelectedDistrictName] = useState(null);
    const [selectedSubDivision, setSelectedSubDivision] = useState(null);
    const [selectedBlock, setSelectedBlock] = useState(null);
    const [selectedYesNo, setSelectedYesNo] = useState(null);
    const [districtData, setDistrictData] = useState([]);  // Initialize with empty array
    const [selectedPanchyat, setSelectedPanchayat] = useState(null);
    const [panchayats, setPanchayats] = useState([]);
    const [yes, setYes] = useState([]);
    const [blocks, setBlocks] = useState([]);  // Initialize as an empty array
    const [data, setData] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);  // Initialize as an empty array
    const [formattedFromDate, setFormattedFromDate] = useState("");
    // Get the query parameters using URLSearchParams
    const queryParams = new URLSearchParams(location.search);
    const Yes = queryParams.get('eposStock');
    const No = queryParams.get('physicalStock');
    // Function to extract last two digits after decimal point
    // Function to format numbers to two decimal places


    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');



    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_API_BASE_URL}/dashboard-data`;

    useEffect(() => {
        const storedFromDate = localStorage.getItem('formattedFromDateForQtl');
        const storedToDate = localStorage.getItem('formateedToDateForQtl');

        if (storedFromDate && storedToDate) {
            const formatDate = (dateString) => {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${year}-${month}-${day}`;
            };

            const formattedFrom = formatDate(storedFromDate);
            const formattedTo = formatDate(storedToDate);

            setFromDate(formattedFrom);
            setToDate(formattedTo);

            if (districtData.length === 0) {
                fetchDistrictData(formattedFrom, formattedTo);
            }
        } else {
            console.error('No date found in localStorage');
        }
    }, []);


    const fetchDistrictData = (from, to) => {
        const apiUrl = `${baseUrl}/all-districts/from/${from}/to/${to}/question/12`;

        axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                // console.log("API Response:", response);  
                // const sortedData = response.data.data.sort((a, b) => {
                // console.log("API Response:", response);  // Log the response
                const sortedData = response.data.sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                });

                setDistrictData(sortedData); // Set the sorted data in state
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };
    const fetchSubDivisionData = (districtUid) => {
        // Ensure the correct uid is passed from district to fetch subdivisions
        if (districtUid) {
            const apiUrl = `${baseUrl}/district/${districtUid}/from/${fromDate}/to/${toDate}/question/12`;

            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    // console.log("SubDivision API Response:", response);  // Log the response
                    const sortedSubDivisions = response.data.sort((a, b) => {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    });

                    setSubDivisions(sortedSubDivisions); // Set the subdivision data in state
                })
                .catch(error => {
                    console.error('Error fetching subdivision data:', error);
                });
        } else {
            console.error('District UID is missing!');
        }
    };

    const fetchBlockData = (subDivisionUid) => {
        // Construct the URL for fetching block data based on the selected subdivision
        const apiUrl = `${baseUrl}/subdivision/${subDivisionUid}/from/${fromDate}/to/${toDate}/question/12`;

        axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                // console.log("Block API Response:", response);  // Log the response
                const sortedBlocks = response.data.sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                });

                setBlocks(sortedBlocks);  // Set the block data in state
            })
            .catch(error => {
                console.error('Error fetching block data:', error);
            });
    };
    const fetchPanchayatData = (blockUid) => {
        // Construct the URL for fetching block data based on the selected subdivision
        const apiUrl = `${baseUrl}/block/${blockUid}/from/${fromDate}/to/${toDate}/question/12`;

        axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                // console.log("Block API Response:", response);  // Log the response
                const sortedPanchayats = response.data.sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                });

                setPanchayats(sortedPanchayats);  // Set the block data in state
            })
            .catch(error => {
                console.error('Error fetching block data:', error);
            });
    };
    const fetchYesorNoData = (panchayatUid, responseType) => {
        // console.log("Fetching data for Panchayat UID:", panchayatUid, "Response Type:", responseType);
        if (!panchayatUid) {
            console.error("panchayatUid is undefined or null");
            return;
        }

        // Construct the URL for fetching data based on the panchayat UID and the response type
        const apiUrl = `${baseUrl}/panchayat/${panchayatUid}/from/${fromDate}/to/${toDate}/question/12/response/${responseType}`;

        axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                // console.log("API Response:", response);
                setYes(response.data);  // Update the 'yes' state with fetched data
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };

    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-IN').format(number); // 'en-IN' for Indian number formatting (commas at appropriate positions)
    };

    const formatDecimal = (value, decimalPlaces = 2) => {
        if (value !== null && value !== undefined) {
            const numberValue = parseFloat(value);
            if (!isNaN(numberValue)) {
                return numberValue.toFixed(decimalPlaces); // Limit to 2 decimal places
            }
        }
        return '0.00'; // Default if the value is not provided or invalid
    };

    // const formattedEposStock = formatDecimal(eposStock, 2); // Format to 2 decimal places
    //const formattedPhysicalStock = formatDecimal(physicalStock, 2); // Format to 2 decimal places
    // Function to download the table as a PDF
    const downloadPDF = () => {
        const doc = new jsPDF();

        // Example: fromDate and toDate should be in Date object format

        doc.addImage(pds, 'jpeg', 9.5, 10, 190, 30); // Image format: 'JPEG'
        doc.setFontSize(18);
        // Get the current date
        const currentDate = new Date();

        // Format the date as dd-mm-yyyy
        const day = String(currentDate.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Get month (months are 0-indexed)
        const year = currentDate.getFullYear(); // Get the year

        const formattedDate = `${day}-${month}-${year}`; // Format as dd-mm-yyyy

        // Now use the formatted date in doc.text()
        doc.text(`Availability of Grievance Register`, 54, 40);

        let yPosition = 45; // Starting Y position

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, 196, yPosition + 13, { align: 'right' });
        yPosition += 5;


        let tableData = []; // This will hold the data for the table
        let title = ''; // This will hold the title for the PDF
        // let Yes = 0, No = 0; // Variables to accumulate totals

        // Set the font to bold for title
        doc.setFont("helvetica", "bold");
        const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
        const formattedToDate = localStorage.getItem('formateedToDateForQtl');
        // Determine which level of data to include
        if (currentLevel === "district") {
            title = `District Wise Inspection Report`;

            // Add title to the PDF
            doc.text(title, 14, yPosition);
            yPosition += 3; // Adjust the yPosition for the date range below the title

            // Format the date range text

            // Set font to normal for the date range and add it below the title
            doc.setFont("helvetica", "normal");
            yPosition += 3; // Move the position down for the table
            doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
            yPosition += 3;
            // Populate the tableData for district level
            tableData = districtData.map((district, index) => {
                return [
                    index + 1,
                    capitalizeFirstLetter(district.name),
                    `${formatNumber(district.yesPercent)}%`,  // Format with 2 decimals and add percentage sign
                    `${formatNumber(district.noPercent)}%`,   // Format with 2 decimals and add percentage sign



                ];
            });
            //console.log('district Data...',districtData);
        } else if (currentLevel === "subdivision") {
            title = `${capitalizeFirstLetter(selectedDistrict)} - Subdivision Wise Inspection Report`;

            // Add title to the PDF
            doc.text(title, 14, yPosition);
            yPosition += 3; // Adjust the yPosition for the date range below the title

            // Format the date range text
            // Set font to normal for the date range and add it below the title
            doc.setFont("helvetica", "normal");
            yPosition += 3; // Move the position down for the table
            doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
            yPosition += 3;
            // Populate the tableData for subdivision level
            tableData = filteredData?.map((subdivision, index) => {
                return [
                    index + 1,
                    capitalizeFirstLetter(subdivision.name),
                    `${formatNumber(subdivision.yesPercent)}%`,  // Format with 2 decimals and add percentage sign
                    `${formatNumber(subdivision.noPercent)}%`,   // Format with 2 decimals and add percentage sign


                ];
            });
            // console.log(filteredData);
        } else if (currentLevel === "block") {
            title = `${capitalizeFirstLetter(selectedDistrict)}-${capitalizeFirstLetter(selectedSubDivision)}-Block Wise Inspection Report`;

            // Add title to the PDF
            doc.text(title, 14, yPosition);
            yPosition += 3; // Adjust the yPosition for the date range below the title


            // Set font to normal for the date range and add it below the title
            doc.setFont("helvetica", "normal");

            yPosition += 3; // Move the position down for the table
            doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
            yPosition += 3;
            // Populate the tableData for block level
            tableData = filteredData?.map((block, index) => {
                return [
                    index + 1,
                    capitalizeFirstLetter(block.name),
                    `${formatNumber(block.yesPercent)}%`,  // Format with 2 decimals and add percentage sign
                    `${formatNumber(block.noPercent)}%`,   // Format with 2 decimals and add percentage sign

                ];
            });
        } else if (currentLevel === "panchayat") {
            title = `${capitalizeFirstLetter(selectedDistrict)}-${capitalizeFirstLetter(selectedSubDivision)}-${capitalizeFirstLetter(selectedBlock)}-Panchyat Wise Inspection Report`;

            // Add title to the PDF
            doc.text(title, 14, yPosition + 2);
            yPosition += 3; // Adjust the yPosition for the date range below the title


            // Set font to normal for the date range and add it below the title
            doc.setFont("helvetica", "normal");

            yPosition += 4; // Move the position down for the table
            doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
            yPosition += 3;
            // Check if panchayat is an array before calling map
            if (Array.isArray(panchayats)) {
                tableData = panchayats.map((panchayat, index) => {
                    return [
                        index + 1,
                        capitalizeFirstLetter(panchayat.name),
                        `${formatNumber(panchayat.yesPercent)}%`,  // Format with 2 decimals and add percentage sign
                        `${formatNumber(panchayat.noPercent)}%`,   // Format with 2 decimals and add percentage sign


                    ];
                });
            } else {
                console.error("panchayat is not an array or is undefined:", panchayats);
            }
        } else if (currentLevel === "yes") {
            title = `${capitalizeFirstLetter(selectedDistrict)}-${capitalizeFirstLetter(selectedSubDivision)}-${capitalizeFirstLetter(selectedBlock)}-${capitalizeFirstLetter(selectedPanchyat)}-${capitalizeFirstLetter(selectedYesNo)}`;
            // Add title to the PDF
            doc.text(title, 14, yPosition);
            yPosition += 3;

            doc.setFont("helvetica", "normal");
            yPosition += 3;
            doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
            yPosition += 3;
            // Table for Inspection Details
            const headers = [
                [
                    "S.No",
                    "FPS ID",
                    "Officer Name",
                    "Date of Inspection",

                ],
            ];
            const inspectionTableData = yes.map((details, index) => {
                return [
                    index + 1, // S.No
                    details.fpsId, // FpsId
                    formatFullName(details.officerFullName), // OfficerName
                    format(new Date(details.surveyStartTime), 'dd-MM-yyyy'), // DateOfInspection
                ];
            });


            doc.autoTable({
                startY: yPosition + 3,
                head: headers,
                body: inspectionTableData,
                headStyles: {
                    fillColor: [255, 165, 0],
                    textColor: [255, 255, 255],
                    fontSize: 10,
                    halign: 'center',
                    valign: 'middle',
                },
                styles: {
                    fontSize: 9,
                    halign: 'center',
                },
                columnStyles: {
                    1: { halign: 'left' },
                },
            });

            yPosition += inspectionTableData;  // Adjust yPosition based on number of rows
        }

        yPosition += 3; // Ensure space between the title/date range and the table

        // Table header based on the current level
        let header;
        if (currentLevel === "district" || currentLevel === "subdivision" || currentLevel === "block" || currentLevel === "panchayat") {
            // For subdivision, block, and panchayat, the table will have similar structure to the district table
            header = [
                [
                    { content: 'S. No' },
                    { content: currentLevel === "district" ? 'district' : currentLevel === "subdivision" ? 'Sub-Division' : currentLevel === "block" ? 'Block' : 'panchayat' },
                    { content: 'Yes %' },
                    { content: 'No %' },
                    //   { content: '% of Deviation in Stock Quantity (Qtl)', rowSpan: 2 },
                ],

            ];
        }

        // Adding the table with dynamic header and data
        doc.autoTable({
            startY: yPosition,
            head: header,  // Table header is defined here
            body: tableData,  // Table body is populated here
            headStyles: {
                fillColor: [255, 165, 0],  // Header color, change as needed
                textColor: [255, 255, 255],  // Text color for header
                fontSize: 10,
                halign: 'center',  // Center header text
                valign: 'middle',  // Vertically center the text
            },
            styles: {
                fontSize: 9,
                halign: 'center',  // Center-align body text
            },
            columnStyles: {
                1: { halign: 'left' },  // Align Name column to left
                2: { halign: 'right' }, // Align Stock/Quantity columns to right
                3: { halign: 'right' },
                4: { halign: 'right' },
                5: { halign: 'right' },
                6: { halign: 'right' },
            },
            didParseCell: (data) => {
                // Apply background color and text color for the last row (total row)
                if (data.row.index === tableData.length) {  // The last row is the total row
                    data.cell.styles.fillColor = [255, 165, 0];  // Background color
                    data.cell.styles.textColor = [255, 255, 255];  // Text color
                    data.cell.styles.fontSize = 10;  // Font size for total row
                }
            },
        });
        //console.log("Title", title);
        //console.log("currentLevel", currentLevel);
        // Save PDF with the dynamic title as filename
        doc.save(`${title.replace(/ /g, '_').replace(/[^a-zA-Z0-9_]/g, '')}.pdf`);
    };
    // console.log(currentLevel);

    const formatDate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0'); // Get day and pad with leading zero if necessary
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Get month (1-based) and pad with leading zero if necessary
        const year = d.getFullYear(); // Get year

        return `${day}-${month}-${year}`; // Return formatted date in DD-MM-YYYY format
    };
    const filteredData =
        currentLevel === "district" ? data :
            currentLevel === "subdivision" ? subDivisions :
                currentLevel === "block" ? blocks :
                    panchayats[selectedBlock] || [];
    const subivisions =
        currentLevel === "subdivision" ? data : currentLevel === "block" ? blocks : blocks[selectedSubDivision] || [];

    const downloadExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Availability of Grievance  Report');

        // Set title for the worksheet (merging cells)
        worksheet.mergeCells('A1:D1');
        worksheet.getCell('A1').value = 'Availability of Grievance  Report';
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } }; // Text color: Light Steel Blue
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }, // Background color: Whitesmoke
        };


        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // Set title for the worksheet (merging cells)
        worksheet.mergeCells('A2:D2');
        worksheet.getCell('A2').value = `Report Date : ${formattedDateTime}`;
        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };
        worksheet.getCell('A2').font = { size: 11, bold: true, color: { argb: '000000' } }; // Text color: Light Steel Blue
        worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }, // Background color: Whitesmoke
        };

        worksheet.mergeCells('A3:D3');
        const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
        const formattedToDate = localStorage.getItem('formateedToDateForQtl');
        worksheet.getCell('A3').value = `Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}     To Date : ${format(formattedToDate, "dd-MM-yyyy")}`;
        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A3').font = { size: 11, bold: true, color: { argb: '000000' } }; // Text color: Light Steel Blue
        worksheet.getCell('A3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }, // Background color: Whitesmoke
        };



        // Set column widths
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A: S.No
            { key: 'B', width: 20 },  // Column B: District/Subdivision/Block/Panchayat
            { key: 'C', width: 25 },  // Column C: Yes
            { key: 'D', width: 25 },  // Column D: No

        ];

        // Define tableData based on the current level
        let tableData = [];

        // Function to generate common table data
        const generateTableData = (data) => {
            return data.map((item, index) => ({
                no: index + 1,
                name: capitalizeFirstLetter(item.name),
                yesPercent: `${formatNumber(item.yesPercent)}%`,
                noPercent: `${formatNumber(item.noPercent)}%`,
            }));
        };

        const generateInspectionDetailsData = (data) => {
            if (data && Array.isArray(data)) {
                //  console.log(data); // Log the data to check the raw response
                return data.map((item, index) => ({
                    no: index + 1, // S.No
                    fpsId: item.fpsId || "N/A", // Default to "N/A" if fpsId is undefined or null
                    name: capitalizeFirstLetter(item.officerFullName), // Officer name
                    surveyStartTime: item.surveyStartTime ? format(new Date(item.surveyStartTime), 'dd-MM-yyyy') : "N/A", // Format the survey start time if available
                }));
            }
        };




        // Based on the current level, map data accordingly
        if (currentLevel === "district") {
            tableData = generateTableData(districtData);
        } else if (currentLevel === "subdivision") {
            tableData = generateTableData(filteredData);
        } else if (currentLevel === "block") {
            tableData = generateTableData(filteredData);
        } else if (currentLevel === "panchayat") {
            tableData = generateTableData(panchayats);
        } else if (currentLevel === "yes") {
            tableData = generateInspectionDetailsData(yes);
        }

        // Function to create and style headers
        // Function to create and style headers
        const createHeaders = (level) => {
            let headerRow;

            if (level === "district" || level === "subdivision" || level === "block" || level === "panchayat") {
                headerRow = [
                    "S.No",
                    capitalizeFirstLetter(currentLevel),
                    "Yes %",
                    "No %",
                ];
            } else if (level === "yes") {
                headerRow = [
                    "S. No",
                    "FPS Id",
                    "Officer Name",
                    "Date of Inspection",
                ];
            }

            // Add header row to worksheet
            worksheet.addRow(headerRow);

            // Set the styling for header cells
            const headerCells = ['A4', 'B4', 'C4', 'D4',];

            headerCells.forEach(cell => {
                const headerCell = worksheet.getCell(cell);
                headerCell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFA500' } // Orange color
                };
                headerCell.font = { bold: true };
                headerCell.alignment = { vertical: 'middle', horizontal: 'center' };
            });
        };

        // Function to add data to the worksheet based on current level
        const addDataRows = (level) => {
            if (level === "district" || level === "subdivision" || level === "block" || level === "panchayat") {
                tableData.forEach(row => {
                    worksheet.addRow([
                        row.no,
                        capitalizeFirstLetter(row.name.trim()),
                        row.yesPercent,
                        row.noPercent,
                    ]);

                    // Set alignment for each column
                    worksheet.getCell(`A${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell(`B${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'left' };
                    worksheet.getCell(`C${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
                    worksheet.getCell(`D${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
                });
            } else if (level === "yes") {
                yes.forEach((details, index) => {


                    worksheet.addRow([
                        index + 1,                         // Serial No
                        details.fpsId,                     // FPS Id
                        formatFullName(details.officerFullName),           // Officer Name
                        format(new Date(details.surveyStartTime), 'dd-MM-yyyy'),                     // Date of Inspection (formatted)
                    ]);

                    // Set alignment for each column
                    worksheet.getCell(`A${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell(`B${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
                    worksheet.getCell(`C${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'left' };
                    worksheet.getCell(`D${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };

                });
            }
        };

        // Create headers based on current level
        createHeaders(currentLevel);

        // Add table data rows based on current level
        addDataRows(currentLevel);

        // Write Excel file to a buffer
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Availability_of_Grievance_Register.xlsx'; // Adjusted filename
            link.click();
        });

    };


    const goBack = () => {
        if (currentLevel === "panchayat") {
            setCurrentLevel("block"); // Go back to block from panchayat
        } else if (currentLevel === "block") {
            setCurrentLevel("subdivision"); // Go back to subdivision from block
        } else if (currentLevel === "subdivision") {
            setCurrentLevel("district"); // Go back to district from subdivision
        } else {
            setCurrentLevel("panchayat");
        }
    };

    const handleDistrictClick = (district) => {
        setSelectedDistrict(district.name);
        setCurrentLevel("subdivision");

        // Fetch subdivision data based on the district UID
        fetchSubDivisionData(district.uid);
    };


    const handleSubDivisionClick = (subDivision) => {
        setSelectedSubDivision(subDivision.name);  // Set the selected subdivision
        setCurrentLevel("block");  // Switch to block level
        fetchBlockData(subDivision.uid);  // Fetch block data
    };

    const handleBlockClick = (blocks) => {
        setSelectedBlock(blocks.name);
        setCurrentLevel("panchayat");
        fetchPanchayatData(blocks.uid); // Fetch data for panchayats
    };
    const handleYesClick = (panchayat) => {
        // console.log("Selected Panchayat:", panchayat); // Log the panchayat object
        const panchayatUid = panchayat.uid;  // Access the uid here
        if (panchayatUid) {
            //setSelectedBlock(panchayat.blockName); // Make sure block is updated
            setSelectedPanchayat(panchayat.name);   // Set the panchayat name
            setCurrentLevel("yes");  // Switch to the 'yes' level to display data
            setSelectedYesNo('YES');  // Set selected YesNo to 'YES'
            fetchYesorNoData(panchayatUid, 'YES');  // Fetch data for YES response
            //  console.log("Selected Block:", selectedBlock);
            //  console.log("Selected Panchayat:", selectedPanchyat);
        } else {
            console.error("Selected Panchayat does not have a valid UID");
        }
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const handleNoClick = (panchayat) => {
        // console.log("Selected Panchayat:", panchayat); // Log the panchayat object
        const panchayatUid = panchayat.uid;  // Access the uid here
        if (panchayatUid) {
            // setSelectedBlock(panchayat.name);
            setSelectedPanchayat(panchayat.name);
            setCurrentLevel("yes");  // Switch to the 'yes' level to display data
            setSelectedYesNo('NO');  // Set selected YesNo to 'No'
            fetchYesorNoData(panchayatUid, 'NO');  // Fetch data for NO response
        } else {
            console.error("Selected Panchayat does not have a valid UID");
        }
    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };

    return (
        <div className="cmrgrievance-1">
            <div className="cmrgrievance-repo">
                <div className="cmrgrievance-header-15">
                    <button className="cmrgrievancecreateUser-btn" onClick={downloadPDF}>
                        DOWNLOAD PDF
                    </button>
                    <button className="cmrgrievancecreateUser-btn" onClick={downloadExcel}>
                        DOWNLOAD XLSX
                    </button>
                </div>
                <div className='cmrgrievanceRegister-1 '>
                    <h3>Weigh Machine Available</h3>
                </div>
                {/* District Table */}
                <div className='cmrgrievence-main-table' >
                    {currentLevel === "district" && (
                        <div className='cmrgrievence-scroll'>
                            <table className="cmrgrievance-table-home">
                                <thead className="cmrgrievance-head-home">
                                    <tr>
                                        <th rowSpan="2">S.No</th>
                                        <th rowSpan="2">District</th>
                                        <th rowSpan="2">Yes %</th>
                                        <th rowSpan="2">No %</th>

                                    </tr>

                                </thead>
                                <tbody className="cmrgrievance-tbody-tr">
                                    {/* Loop through districts data and create a row for each */}
                                    {districtData.map((district, index) => (
                                        <tr key={district.uid} onClick={() => handleDistrictClick(district)}>
                                            <td>{index + 1}</td>
                                            <td>{district.name}</td>
                                            <td>{district.yesPercent.toFixed(2)}%</td>
                                            <td>{district.noPercent.toFixed(2)}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {currentLevel === "subdivision" && (
                        <div className="subdivision-table">
                            <button onClick={goBack} className="back-button">Back</button>
                            <h3>{capitalizeFirstLetter(selectedDistrict)}</h3>

                            <div className='cmrgrievence-scroll'>
                                <table className="cmrgrievance-table-home">
                                    <thead className="cmrgrievance-head-home">
                                        <tr>
                                            <th rowSpan="2">S.No</th>
                                            <th rowSpan="2">Sub-Division</th>
                                            <th rowSpan="2">Yes %</th>
                                            <th rowSpan="2">No %</th>

                                        </tr>

                                    </thead>
                                    <tbody className="cmrgrievance-tbody-tr">
                                        {subDivisions.map((subDivision, index) => (
                                            <tr key={subDivision.uid} onClick={() => handleSubDivisionClick(subDivision)}>
                                                <td>{index + 1}</td>
                                                <td>{capitalizeFirstLetter(subDivision.name)}</td>
                                                <td>{subDivision.yesPercent.toFixed(2)}%</td>
                                                <td>{subDivision.noPercent.toFixed(2)}%</td>
                                            </tr>
                                        ))}
                                        {/* Add more rows as necessary */}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {currentLevel === "block" && (
                        <div className="block-table">
                            <button onClick={goBack} className="back-button">Back</button>
                            <h3>{capitalizeFirstLetter(selectedDistrict)} - {capitalizeFirstLetter(selectedSubDivision)}</h3>
                            <div className='cmrgrievence-scroll'>
                                <table className="cmrgrievance-table-home">
                                    <thead className="cmrgrievance-head-home">
                                        <tr>
                                            <th rowSpan="2">S.No</th>
                                            <th rowSpan="2">Block</th>
                                            <th rowSpan="2">Yes %</th>
                                            <th rowSpan="2">No %</th>

                                        </tr>

                                    </thead>
                                    <tbody className="cmrgrievance-tbody-tr">

                                        {blocks.map((blocks, index) => (
                                            <tr key={blocks.uid} onClick={() => handleBlockClick(blocks)}>
                                                <td>{index + 1}</td>
                                                <td>{capitalizeFirstLetter(blocks.name)}</td>
                                                <td>{blocks.yesPercent.toFixed(2)}%</td>
                                                <td>{blocks.noPercent.toFixed(2)}%</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {currentLevel === "panchayat" && (
                        <div className="panchayat-table">
                            <button onClick={goBack} className="back-button">Back</button>
                            <h3>{capitalizeFirstLetter(selectedDistrict)} - {capitalizeFirstLetter(selectedSubDivision)}-{capitalizeFirstLetter(selectedBlock)}</h3>
                            <div className='cmrgrievence-scroll'>
                                <table className="cmrgrievance-table-home">
                                    <thead className="cmrgrievance-head-home">
                                        <tr>
                                            <th rowSpan="2">S.No</th>
                                            <th rowSpan="2">Panchayat</th>
                                            <th rowSpan="2">Yes %</th>
                                            <th rowSpan="2">No %</th>
                                        </tr>
                                    </thead>
                                    <tbody className="grievance-tbody-t">
                                        {panchayats.map((panchayat, index) => (
                                            <tr key={panchayat.uid}>
                                                <td>{index + 1}</td>
                                                <td>{capitalizeFirstLetter(panchayat.name.trim())}</td>
                                                <td onClick={() => handleYesClick(panchayat)} style={{ cursor: 'pointer' }}>
                                                    {panchayat.yesPercent.toFixed(2)}%
                                                </td>
                                                <td onClick={() => handleNoClick(panchayat)} style={{ cursor: 'pointer' }}>
                                                    {panchayat.noPercent.toFixed(2)}%
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    )}
                    {currentLevel === "yes" && (
                        <div className="inspection-details">
                            <button onClick={goBack} className="back-button">Back</button>
                            <h3>{capitalizeFirstLetter(selectedDistrict)} - {capitalizeFirstLetter(selectedSubDivision)} - {capitalizeFirstLetter(selectedBlock)} - {capitalizeFirstLetter(selectedPanchyat)}-{capitalizeFirstLetter(selectedYesNo)}</h3>
                            <div className='cmrgrievence-scroll'>
                                <table className="MeasuringEquipment-table-home">
                                    <thead className="MeasuringEquipment-head-home">
                                        <tr>
                                            <th>S.No</th>
                                            <th>FpsId</th>
                                            <th>Officer Name</th>
                                            <th>Date of Inspection</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {yes && yes.length > 0 ? (
                                            yes.map((details, index) => (
                                                <tr key={details.fpsId}>
                                                    <td>{index + 1}</td>
                                                    <td>{details.fpsId}</td>
                                                    <td>{formatFullName(details.officerFullName)}</td>
                                                    <td>{format(new Date(details.surveyStartTime), 'dd-MM-yyyy')}</td> {/* Format the timestamp */}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CmrGrievanceRegister;